import { useTheme } from '@mui/material/styles';
import useMediaQuery from "@mui/material/useMediaQuery";

export type ResponsiveReturnType = {
    xsmall: boolean,
    small: boolean,
    medium: boolean,
    large: boolean,
    xlarge: boolean,

    minSmall: boolean,
    minMedium: boolean,
    minLarge: boolean,    
    
    maxSmall: boolean,
    maxMedium: boolean,
    maxLarge: boolean,
}

export default function useResponsive() {
    const theme = useTheme();    
    const xlarge = useMediaQuery(theme.breakpoints.up('xl'));
    const large = useMediaQuery(theme.breakpoints.up('lg')) && !xlarge;
    const medium = useMediaQuery(theme.breakpoints.up('md')) && !large && !xlarge;
    const small = useMediaQuery(theme.breakpoints.up('sm')) && !medium && !large && !xlarge;
    const xsmall = useMediaQuery(theme.breakpoints.down('sm')) && !small&& !medium && !large && !xlarge;

    const minSmall = small || medium || large || xlarge;
    const minMedium = medium || large || xlarge;
    const minLarge = large || xlarge;
    
    const maxSmall = xsmall || small;
    const maxMedium = xsmall || small || medium;
    const maxLarge = xsmall || small || medium || large;

    return {xsmall, small, medium, large, xlarge, minSmall, minMedium, minLarge, maxSmall, maxMedium, maxLarge} as ResponsiveReturnType;
}